import $ from 'jquery';
import slider from '../slider/c-slider';
import homepageSlider from '../slider/c-slider-homepage';
import timelineSlider from '../slider/c-slider-timeline';

// other configs go here.
const doubleSlideCustomOpts = {
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                prevArrow: false,
                nextArrow: false
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                prevArrow: false,
                nextArrow: false
            }
        }
    ]
};

const fourColTileOpts = {
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1600,
            settings: {
                dots: false,
                slidesToShow: 4,
                slidesToScroll: 1
            }
        }
    ],
    dots: false
};

// default slider has no changes to the config
$(() => {
    if ($('.default-slider').length > 0) {
        slider('default-slider');
    }

    if ($('.c-slider-homepage').length > 0) {
        homepageSlider('c-slider-homepage');
    }

    if ($('.double-slides').length > 0) {
        slider('double-slides', doubleSlideCustomOpts);
    }

    if ($('.cw-four-col-tile-slider').length > 0) {
        slider('cw-four-col-tile-slider', fourColTileOpts);
    }

    if ($('.c-slider-timeline').length > 0) {
        timelineSlider('c-slider-timeline');
    }
});



// WEBPACK FOOTER //
// ./src/components/slider/c-slider-configs.js